import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  Renderer2,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import { AlertService } from "@shared";
import { ExportService } from "src/app/export.service";

@Component({
  selector: "app-bibrain-output",
  templateUrl: "./bibrain-output.component.html",
  styleUrls: ["./bibrain-output.component.scss"],
})
export class BibrainOutputComponent implements OnInit, OnChanges {
  @Input() response: string = "";
  showResponse = false;
  insightsResponse;
  isLoading = false;
  waitingMessage = false;
  safeHtml: SafeHtml;
  showError = false;
  isPie: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private alertService: AlertService,
    private exportService: ExportService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.response && this.response !== "") {
      this.showResponse = true;
      const scriptStartIndex = this.response.indexOf("scriptstart");
      const scriptEndIndex = this.response.indexOf("scriptend");

      if (scriptStartIndex > -1 && scriptEndIndex > -1) {
        this.loadChartLibrary(
          this.response.substring(scriptStartIndex + 11, scriptEndIndex - 2)
        );
      }

      const htmlStartIndex = this.response.indexOf("<html");
      const htmlEndIndex = this.response.indexOf("</html");

      if (htmlStartIndex > -1 && htmlEndIndex > -1) {
        this.insightsResponse = this.response.substring(
          htmlStartIndex,
          htmlEndIndex
        );
      }
    } else {
      this.showResponse = false;
    }
  }

  loadChartLibrary(chartConfiguration: string): void {
    this.searchString(chartConfiguration);

    const finalString = this.performSearchAndReplace(chartConfiguration);
    const scriptElement = this.renderer.createElement("script");
    scriptElement.src = "https://cdn.jsdelivr.net/npm/chart.js";
    scriptElement.onload = () => {
      try {
        eval(finalString);
      } catch (e) {
        this.showError = true;
      }
    };
    this.renderer.appendChild(document.body, scriptElement);
  }

  copyToClipboard() {
    const richText = document.getElementById("insights").innerHTML;
    const blobHtml = new Blob([richText], { type: "text/html" });
    const data = [
      new ClipboardItem({
        ["text/html"]: blobHtml,
      }),
    ];

    navigator.clipboard.write(data).then(
      () => {
        this.alertService.openSnackBar("Copied to clipboard successfully!");
      },
      () => {}
    );
  }

  performSearchAndReplace(string: string): string {
    if (string) {
      string = string.replace("ordinal", "linear");
      return string;
    } else {
      return string;
    }
  }

  exportAsPdf() {
    let opt = {
      margin: 1,
      filename: "myfile.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "cm", format: "letter", orientation: "portrait" },
    };

    this.exportService.exportAsPdf("downloadableContent", opt);
  }

  searchString(codeString) {
    let searchString = "pie";
    let indexOfPie = codeString.indexOf(searchString);
    if (indexOfPie !== -1) {
      this.isPie = true;
    } else {
      this.isPie = false;
    }
  }

  getStyle(isMenuOpened) {
    if (isMenuOpened && !this.isPie) {
      return "width: 600px;height: 450px;";
    } else {
      return "width: 900px;height: 450px;";
    }
  }
}
